import { useDeferredValue, useState } from 'react';
import { DropDownOption } from 'src/types';

/** Хук для управления состоянием подсказок автокомплита */
export function useSuggestions(options: DropDownOption[]) {
  const [_suggestions, setSuggestions] = useState(options);
  const suggestions = useDeferredValue(_suggestions);

  const filterOptions = (value: string) => {
    const v = value.toLowerCase();
    return options.filter((o) => o.name.toLowerCase().includes(v));
  };

  return {
    suggestions,
    setSuggestions,
    filterOptions
  };
}
